import { ReactNode } from "react";
import classNames from "./LandingContentPage.module.css";
import Footer from "./Footer";

const LandingContentPage = (props: { children: ReactNode }) => {
  return (
    <>
      <div className={classNames.LandingContentPage}>{props.children}</div>
      <Footer />
    </>
  );
};

export default LandingContentPage;
